import { Components, Theme, toggleButtonClasses } from '@mui/material';

type ReturnType = Record<'MuiToggleButton', Components['MuiToggleButton']>;

export default function ToggleButton(theme: Theme): ReturnType {
  return {
    MuiToggleButton: {
      defaultProps: {
        disableFocusRipple: true,
        disableRipple: true,
        disableTouchRipple: true,
      },
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.background.primary,
          color: theme.palette.text.secondary,
          textTransform: 'none',
          [`&.${toggleButtonClasses.selected}`]: {
            backgroundColor: theme.palette.background.active,
            color: theme.palette.text.secondary,
            '&:hover': {
              backgroundColor: theme.palette.background.active,
            },
          },
          [`&.${toggleButtonClasses}`]: {
            backgroundColor: theme.palette.background.disabled,
          },
          [`&.${toggleButtonClasses.standard}`]: {
            border: '1px solid',
            borderColor: theme.palette.border.primary,
          },
        },
      },
    },
  };
}
